<template>
  <div class="navWrapper">
    <div id="menu" :class="{ active: isActive }">
      <el-menu class="logobar" mode="horizontal" @select="handleSelect" :router="true">
      <el-menu-item id="logo" index="/home" :route="{ name: 'Home'}">
        <logo></logo>
      </el-menu-item>
      
      <!-- <el-menu-item index="/contact" :route="{ name: 'Contact' }">
        Contact
      </el-menu-item> -->
      </el-menu>
      <el-menu class="menubar" mode="horizontal" @select="handleSelect" :router="true">

      <el-menu-item index="/home" :route="{ name: 'Home' }">
        Home
      </el-menu-item>
      <el-menu-item index="/joblist" :route="{ name: 'Joblist' }">
        JobList
      </el-menu-item>
      <el-menu-item index="/about" :route="{ name: 'About' }">
        About
      </el-menu-item>
      </el-menu>

    </div>
    <div id="toggle" @click="select()">
      <div class="span" id="top" :class="{ active: isActive }"></div>
      <div class="span" id="middle" :class="{ active: isActive }"></div>
      <div class="span" id="bottom" :class="{ active: isActive }"></div>
    </div>
  </div>
</template>

<script>
// import Logo from '@/components/Logo'
import Logo from '@/components/Logo'
export default {
  components: {
    Logo
  },
  data() {
    return {
      activeIndex: '/hello',
      isActive: false
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    select: function() {
      this.isActive = !this.isActive;
    }
  }
}
</script>

<style scoped>

el-menu{
  width: 100%;
  height: auto;
}
.menubar{
  padding: 0 65px;
}


  .logo-header {
    padding-left: 15px;
    padding-right: 50px;
    z-index: 100;
  }

  .navWrapper {
    width: 100%;
    position: fixed;
    top: 0;
  }

  #logo.el-menu-item.is-active {
    border-bottom-color: transparent;
  }

  #toggle {
    position: absolute;
    right: 20px;
    top: 14px;
    z-index: 999;
    width: 40px;
    height: 40px;
    cursor: pointer;
    float: right;
    transition: all .3s ease-out;
    visibility: hidden;
    opacity: 0;
  }

  #toggle .span {
    border-radius: 10px;
    background: #0E5FC2;
    transition: all 0.3s ease-out;
    backface-visibility: hidden;
  }

  #top.span.active {
    transform: rotate(45deg) translateX(3px) translateY(5px);
  }

  #middle.span.active {
    opacity: 0;
  }

  #bottom.span.active {
    transform: rotate(-45deg) translateX(8px) translateY(-10px);
  }

  /* @media only screen and (max-width: 768px) {

    .logo-header {
      padding: 0;
    }

    #toggle {
      visibility: visible;
      opacity: 1;
      margin-top: 6px;
    }

    #toggle .span {
      height: 4px;
      margin: 5px 0;
      transition: all .3s ease-out;
      backface-visibility: visible;
      visibility: visible;
      opacity: 1;
    }

    #menu .el-menu-item {
      display: none;
    }

    #menu.active {
      margin: 70px 0;
      visibility: visible;
      opacity: 0.98;
      transition: all .5s ease-out;
    }
    @media screen and (max-width: 576px){
        .el-menu--horizontal .el-menu-item {
            text-align: center;
            float: none;
            display: block;
            height: 100%;
            width: 100%;
            border-top: 1px solid #EAEAEB;
            font-size: 18px;
        }
    }
  } */


</style>